// Sleek loading skeleton for outstanding aesthetics and user experience
export default function LoadingSkeleton() {
  return (
    <div className="max-w-3xl  py-2 px-2  animate-pulse">
      {/* Title skeleton */}
      <div className="h-10 bg-zinc-200 rounded w-1/2 mb-3"></div>

      <div className="space-y-8">
        {/* Card skeleton 1 */}
        <div className="bg-white border border-zinc-100 rounded-xl p-6 md:p-8 space-y-6 shadow-sm">
          <div className="h-6 bg-zinc-200 rounded w-3/4"></div>
          <div className="flex gap-2 justify-between">
            {Array.from({ length: 10 }).map((_, i) => (
              <div
                key={i}
                className="w-8 h-8 md:w-10 md:h-10 bg-zinc-200 rounded-full"
              ></div>
            ))}
          </div>
          <div className="flex justify-between w-full h-4">
            <div className="h-3 bg-zinc-200 rounded w-24"></div>
            <div className="h-3 bg-zinc-200 rounded w-16"></div>
          </div>
        </div>

        {/* Card skeleton 2 */}
        <div className="bg-white border border-zinc-100 rounded-xl p-6 md:p-8 space-y-6 shadow-sm">
          <div className="h-6 bg-zinc-200 rounded w-2/3"></div>
          <div className="h-28 bg-zinc-200 rounded w-full"></div>
        </div>
      </div>
    </div>
  );
}
